// FE-SCRM-054 — Global-search shared types.
//
// Matches the BE-SCRM-054 endpoint payload at /api/v1/sales/search.

export type SearchEntityType =
  | "prospects"
  | "sales_contacts"
  | "opportunities"
  | "carriers"
  | "carrier_contacts";


export interface SearchResultRow {
  id: string;
  label: string;
  sublabel: string | null;
  route: string;
  // FE-SCRM-059 — opportunity rows carry their parent prospect_id so
  // the activity composer can auto-derive both anchors from one
  // selection. Always null on non-opportunity rows.
  prospect_id?: string | null;
}


export interface GlobalSearchResponse {
  prospects: SearchResultRow[];
  sales_contacts: SearchResultRow[];
  opportunities: SearchResultRow[];
  carriers: SearchResultRow[];
  carrier_contacts: SearchResultRow[];
}


// Display order in the modal — chosen to match the typical
// producer mental model (companies first, then deals, then people,
// then carriers).
export const ENTITY_TYPE_ORDER: readonly SearchEntityType[] = [
  "prospects",
  "opportunities",
  "sales_contacts",
  "carriers",
  "carrier_contacts",
] as const;


export const ENTITY_TYPE_LABEL: Record<SearchEntityType, string> = {
  prospects: "Prospects",
  opportunities: "Opportunities",
  sales_contacts: "Sales contacts",
  carriers: "Carriers",
  carrier_contacts: "Carrier contacts",
};
